import React, { useCallback, useLayoutEffect, useMemo, useRef, useState, } from "react";
import { Popover } from "@blueprintjs/core";
import classNames from "classnames";
import HtmlText from "../HtmlText";
import useDebounce from "hooks/useDebounce";
import { isHtml } from "utils/string";
import * as styles from "./styles.module.scss";
const TextTruncate = ({ text, title, showTitle = true, wrapText, className, popoverPortalClassName, onClick, children, forceOpenTitle, openDuration = 1000, defaultTitleIsOpen, style, }) => {
    const textRef = useRef(null);
    const [isTruncated, setIsTruncated] = useState(true);
    const [isTitleOpen, setIsTitleOpen] = useState(false);
    const debounceIsOpen = useDebounce(isTitleOpen, isTitleOpen ? openDuration : 0);
    const compareSize = useCallback(() => {
        const { current } = textRef;
        if (current) {
            const shouldTruncate = current.scrollWidth > current.clientWidth;
            setIsTruncated(shouldTruncate);
            if (shouldTruncate) {
                setIsTitleOpen(!!forceOpenTitle);
            }
        }
    }, [forceOpenTitle]);
    useLayoutEffect(() => {
        compareSize();
        window.addEventListener("resize", compareSize);
        return () => {
            window.removeEventListener("resize", compareSize);
        };
    }, [compareSize]);
    const textIsHtml = useMemo(() => isHtml(text), [text]);
    const titleContent = useMemo(() => {
        if ((isTruncated || title) && showTitle) {
            if (!title) {
                return textIsHtml ? React.createElement(HtmlText, { text: text }) : text;
            }
            return title;
        }
        return "";
    }, [isTruncated, showTitle, text, textIsHtml, title]);
    return (React.createElement(Popover, { usePortal: true, defaultIsOpen: defaultTitleIsOpen, isOpen: debounceIsOpen, className: classNames(styles.root, { [styles.wrapText]: wrapText }, className), content: titleContent, disabled: !isTruncated && !title && showTitle, placement: "bottom-start", popoverClassName: styles.popover, portalClassName: classNames(styles.popoverPortal, popoverPortalClassName), transitionDuration: 100 },
        React.createElement("span", { onClick: onClick, ref: textRef, className: styles.text, style: style, onMouseEnter: () => {
                compareSize();
                !forceOpenTitle && setIsTitleOpen(true);
            }, onMouseLeave: () => !forceOpenTitle && setIsTitleOpen(false), ...(textIsHtml && !children && { dangerouslySetInnerHTML: { __html: text } }), ...((!textIsHtml || children) && {
                children: (React.createElement(React.Fragment, null,
                    text,
                    children)),
            }) })));
};
export default TextTruncate;
